import React, { useState } from "react";
import { Mail, User, Lock, Eye } from "lucide-react";

/**
 * Par de campos email/usuario + contraseña, con el ojo para mostrarla.
 * Lo comparten todos los logins de portal: antes cada uno tenía su copia.
 *
 * El estado de "mostrar contraseña" se queda acá, que es donde se usa;
 * la página solo maneja los valores y el submit.
 *
 * Los campos llevan aria-label además del placeholder: el placeholder sirve
 * de nombre accesible de último recurso, pero se borra apenas escribís.
 *
 * @param {string}   userLabel   Texto del primer campo. Por defecto "Email".
 * @param {string}   userType    "email" (default) o "text" para usuario.
 * @param {string}   value       Valor del primer campo.
 * @param {func}     onValue     Cambio del primer campo, recibe el string.
 * @param {string}   password
 * @param {func}     onPassword
 * @param {func}     onEnter     Se dispara al apretar Enter en cualquiera.
 */
const PortalLoginFields = ({
    userLabel = "Email",
    userType = "email",
    value,
    onValue,
    password,
    onPassword,
    onEnter,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const onKeyDown = (e) => {
        if (e.key === "Enter" && onEnter) onEnter();
    };

    return (
        <>
            <div className="login-field">
                <input
                    className="login-input"
                    placeholder={userLabel}
                    aria-label={userLabel}
                    type={userType}
                    value={value}
                    onChange={(e) => onValue(e.target.value)}
                    onKeyDown={onKeyDown}
                    autoComplete={userType === "email" ? "email" : "username"}
                />
                <span className="login-field-icon">
                    {userType === "email" ? <Mail size={16} /> : <User size={16} />}
                </span>
            </div>

            <div className="login-field">
                <input
                    className="login-input"
                    placeholder="Contraseña"
                    aria-label="Contraseña"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => onPassword(e.target.value)}
                    onKeyDown={onKeyDown}
                    autoComplete="current-password"
                />
                <button
                    type="button"
                    className="login-field-icon"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                >
                    {showPassword ? <Eye size={16} /> : <Lock size={16} />}
                </button>
            </div>
        </>
    );
};

export default PortalLoginFields;
